module.exports = __webpack_public_path__ + "img/success.08c941a6.png";